@use '~@frontrow/console/css/variables.scss';

@forward '~@frontrow/console/css/variables.scss';

.schoolLicensesContainer {
  margin-top: variables.$std-margin-4xl;
  width: 1300px;
}
